import React, { useEffect, useState, Children } from 'react';
import { Phone, Facebook, Youtube, Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/Button';
import { Container } from './ui/Container';
export function Navbar() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const toggleDropdown = (name: string) => {
    if (activeDropdown === name) {
      setActiveDropdown(null);
    } else {
      setActiveDropdown(name);
    }
  };
  return <header className="w-full relative z-50" data-id="element-299">
      {/* SECTION A: Utility Bar */}
      <div className="bg-utility-bar text-white py-1.5 text-xs sm:text-sm font-body border-b border-gray-700" data-id="element-300">
        <Container className="flex justify-between items-center" data-id="element-301">
          <div className="font-medium tracking-wide" data-id="element-302">
            Round Lake Taekwondo for Kids & Adults • Kukkiwon Affiliated
          </div>
          <div className="flex items-center gap-4" data-id="element-303">
            <a href="tel:8472128045" className="hover:text-accent transition-colors flex items-center" data-id="element-304">
              <Phone className="w-3 h-3 mr-1" data-id="element-305" />
              <span className="hidden sm:inline" data-id="element-306">847-212-8045</span>
            </a>
            <div className="h-3 w-px bg-gray-500 hidden sm:block" data-id="element-307"></div>
            <a href="https://www.facebook.com/DragonMartialArtsofRoundLake" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors" aria-label="Facebook" data-id="element-308">
              <Facebook className="w-3.5 h-3.5" data-id="element-309" />
            </a>
            <a href="https://www.youtube.com/channel/UCuJLpS3IFW06RbZAo-l7mtA?view_as=subscriber" target="_blank" rel="noopener noreferrer" className="hover:text-accent transition-colors" aria-label="YouTube" data-id="element-310">
              <Youtube className="w-3.5 h-3.5" data-id="element-311" />
            </a>
            <a href="#signup" className="ml-2 text-accent font-bold hover:text-white transition-colors uppercase text-xs" data-id="element-312">
              Free Trial
            </a>
          </div>
        </Container>
      </div>

      {/* SECTION B: Sticky Header */}
      <nav className={`bg-nav sticky top-0 transition-all duration-300 ${isScrolled ? 'shadow-xl py-0' : 'py-2'}`} data-id="element-313">
        <Container data-id="element-314">
          <div className={`flex justify-between items-center transition-all duration-300 ${isScrolled ? 'h-16' : 'h-20'}`} data-id="element-315">
            {/* Logo */}
            <a href="https://dragonmartialarts-rl.com/" className="flex-shrink-0" data-id="element-316">
              <img src="https://dragonmartialarts-rl.com/wp-content/uploads/2018/12/cropped-site-logo-1-3-1.jpg" alt="Dragon Martial Arts of Round Lake" className={`w-auto transition-all duration-300 ${isScrolled ? 'h-10' : 'h-12 sm:h-14'}`} data-id="element-317" />
            </a>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-6" data-id="element-318">
              <NavLink href="https://dragonmartialarts-rl.com/" data-id="element-319">Home</NavLink>

              <NavDropdown title="About Us" href="https://dragonmartialarts-rl.com/about-us/" data-id="element-320">
                <DropdownItem href="https://dragonmartialarts-rl.com/hdz-sitemap/" data-id="element-321">
                  SiteMap
                </DropdownItem>
              </NavDropdown>

              <NavDropdown title="Classes" href="#" data-id="element-322">
                <DropdownItem href="https://dragonmartialarts-rl.com/children-classes/" data-id="element-323">
                  Children
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/child-adults-classes/" data-id="element-324">
                  Child – Adults
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/cardio-kickboxing/" data-id="element-325">
                  Cardio Kickboxing
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/advanced/" data-id="element-326">
                  Advanced Classes
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/sparring/" data-id="element-327">
                  Sparring
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/demo-team/" data-id="element-328">
                  Demo Team
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/fit-kids-program/" data-id="element-329">
                  Fit Kids Program
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/class-schedules/" data-id="element-330">
                  Class Schedules
                </DropdownItem>
              </NavDropdown>

              <NavDropdown title="Resources" href="#" data-id="element-331">
                <DropdownItem href="https://dragonmartialarts-rl.com/tkd-resources/" data-id="element-332">
                  TKD Resources
                </DropdownItem>
                <DropdownItem href="https://dragonmartialarts-rl.com/student-information-packet/" data-id="element-333">
                  Student Info Packet
                </DropdownItem>
              </NavDropdown>

              <NavLink href="https://dragonmartialarts-rl.com/contact-us/" data-id="element-334">
                Contact
              </NavLink>

              <div className="flex items-center gap-3 ml-4 pl-4 border-l border-gray-700" data-id="element-335">
                <a href="tel:8472128045" className="text-white hover:text-accent font-bold text-sm hidden xl:block" data-id="element-336">
                  (847) 212-8045
                </a>
                <a href="#signup" data-id="element-337">
                  <Button variant="primary" size={isScrolled ? 'sm' : 'md'} className="whitespace-nowrap" data-id="element-338">
                    Get One Week Free Trial
                  </Button>
                </a>
              </div>
            </div>

            {/* Mobile Menu Button */}
            <div className="lg:hidden flex items-center gap-4" data-id="element-339">
              <a href="tel:8472128045" className="text-white hover:text-accent" data-id="element-340">
                <Phone className="w-5 h-5" data-id="element-341" />
              </a>
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="text-white hover:text-accent p-1" data-id="element-342">
                {isMobileMenuOpen ? <X className="w-7 h-7" data-id="element-343" /> : <Menu className="w-7 h-7" data-id="element-344" />}
              </button>
            </div>
          </div>
        </Container>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <div className="lg:hidden bg-nav border-t border-gray-800 absolute w-full left-0 shadow-xl max-h-[80vh] overflow-y-auto" data-id="element-345">
            <div className="px-4 pt-4 pb-8 space-y-2" data-id="element-346">
              <MobileNavLink href="https://dragonmartialarts-rl.com/" data-id="element-347">
                Home
              </MobileNavLink>

              <MobileNavDropdown title="About Us" isOpen={activeDropdown === 'about'} onToggle={() => toggleDropdown('about')} data-id="element-348">
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/about-us/" data-id="element-349">
                  About Us
                </MobileDropdownItem>
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/hdz-sitemap/" data-id="element-350">
                  SiteMap
                </MobileDropdownItem>
              </MobileNavDropdown>

              <MobileNavDropdown title="Classes" isOpen={activeDropdown === 'classes'} onToggle={() => toggleDropdown('classes')} data-id="element-351">
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/children-classes/" data-id="element-352">
                  Children
                </MobileDropdownItem>
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/child-adults-classes/" data-id="element-353">
                  Child – Adults
                </MobileDropdownItem>
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/cardio-kickboxing/" data-id="element-354">
                  Cardio Kickboxing
                </MobileDropdownItem>
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/advanced/" data-id="element-355">
                  Advanced Classes
                </MobileDropdownItem>
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/sparring/" data-id="element-356">
                  Sparring
                </MobileDropdownItem>
                <MobileDropdownItem href="https://dragonmartialarts-rl.com/fit-kids-program/" data-id="element-357">
                  Fit Kids Program
                </MobileDropdownItem>
              </MobileNavDropdown>

              <MobileNavLink href="https://dragonmartialarts-rl.com/contact-us/" data-id="element-358">
                Contact Us
              </MobileNavLink>

              <div className="pt-6 space-y-3" data-id="element-359">
                <a href="#signup" className="block w-full" onClick={() => setIsMobileMenuOpen(false)} data-id="element-360">
                  <Button variant="primary" fullWidth size="lg" data-id="element-361">
                    Get One Week Free Trial
                  </Button>
                </a>
                <a href="tel:8472128045" className="block w-full" data-id="element-362">
                  <Button variant="secondary" fullWidth data-id="element-363">
                    Call (847) 212-8045
                  </Button>
                </a>
              </div>
            </div>
          </div>}
      </nav>
    </header>;
}
function NavLink({
  href,
  children
}: {
  href: string;
  children: React.ReactNode;
}) {
  return <a href={href} className="text-white hover:text-accent font-medium text-sm transition-colors font-heading uppercase tracking-wide" data-id="element-364">
      {children}
    </a>;
}
function NavDropdown({
  title,
  href,
  children
}: {
  title: string;
  href: string;
  children: React.ReactNode;
}) {
  return <div className="relative group" data-id="element-365">
      <a href={href} className="flex items-center text-white hover:text-accent font-medium text-sm transition-colors font-heading uppercase tracking-wide py-6" data-id="element-366">
        {title}
        <ChevronDown className="w-3 h-3 ml-1" data-id="element-367" />
      </a>
      <div className="absolute left-0 top-full w-56 bg-white shadow-xl rounded-b-sm opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 transform origin-top z-50 border-t-2 border-accent" data-id="element-368">
        <div className="py-2 flex flex-col" data-id="element-369">{children}</div>
      </div>
    </div>;
}
function DropdownItem({
  href,
  children
}: {
  href: string;
  children: React.ReactNode;
}) {
  return <a href={href} className="px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-accent transition-colors border-b border-gray-100 last:border-0" data-id="element-370">
      {children}
    </a>;
}
function MobileNavLink({
  href,
  children
}: {
  href: string;
  children: React.ReactNode;
}) {
  return <a href={href} className="block px-3 py-3 text-base font-medium text-white hover:text-accent hover:bg-gray-800 rounded-md border-b border-gray-800" data-id="element-371">
      {children}
    </a>;
}
function MobileNavDropdown({
  title,
  isOpen,
  onToggle,
  children
}: {
  title: string;
  isOpen: boolean;
  onToggle: () => void;
  children: React.ReactNode;
}) {
  return <div className="border-b border-gray-800" data-id="element-372">
      <button onClick={onToggle} className="flex items-center justify-between w-full px-3 py-3 text-base font-medium text-white hover:text-accent hover:bg-gray-800 rounded-md" data-id="element-373">
        {title}
        <ChevronDown className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-374" />
      </button>
      {isOpen && <div className="pl-4 space-y-1 bg-gray-800/30 pb-2" data-id="element-375">{children}</div>}
    </div>;
}
function MobileDropdownItem({
  href,
  children
}: {
  href: string;
  children: React.ReactNode;
}) {
  return <a href={href} className="block px-3 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-700 rounded-md" data-id="element-376">
      {children}
    </a>;
}